import { PresenceZone } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function usePresenceZones(camId: string, enabled = true) {
  const url = `/v2/orm/presence/cameras/${camId}/zones`;
  const request = new Request(url);

  return useAuthenticatedRequest<PresenceZone[]>(request, {
    queryKey: ['presence-zones', camId],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload.items;
    },
    enabled,
  });
}

export default usePresenceZones;
